import React from 'react';

const Flag = (props) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.13641 1.60815C4.75 0.746252 2.63874 0.849971 2 1.60815V7.10815C2.63874 6.34997 4.75 6.24625 6.13641 7.10815C8.04689 8.29585 9.65434 7.73844 10.5 7.10815V4.39664V1.60815C9.65434 2.23844 8.04689 2.79585 6.13641 1.60815Z"
        fill="currentColor"
      />
      <path
        d="M2 11V1.60815C2.63874 0.849971 4.75 0.746252 6.13641 1.60815C8.04689 2.79585 9.65434 2.23844 10.5 1.60815V4.39664V7.10815C9.65434 7.73844 8.04689 8.29585 6.13641 7.10815C4.75 6.24625 2.63874 6.34997 2 7.10815"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Flag;
